
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/build-rag-system",
      function () {
        return require("private-next-pages/docs/build-rag-system.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/build-rag-system"])
      });
    }
  